import { useChargingFeeDiscountTargetEnum } from '@services/chargingFee'
import { Select, SelectProps } from '@shared/Form/Select'
import { DefaultOptionType } from 'antd/lib/select'

export const ChargingFeeDiscountTargetSelect = (
  props: SelectProps<number[]>
) => {
  const { onChange, value = [], ...others } = props

  const { data } = useChargingFeeDiscountTargetEnum()

  const handleChange = (
    value: number[],
    option: DefaultOptionType | DefaultOptionType[]
  ) => {
    if (value.includes(0)) {
      onChange?.([0], option)
    } else {
      onChange?.(value, option)
    }
  }

  return (
    <Select
      allowClear
      mode="multiple"
      onChange={handleChange}
      value={value}
      {...others}>
      {(data || []).map(({ id, label }) => (
        <Select.Option
          key={id}
          value={id}
          disabled={value?.includes(0) && id !== 0}>
          {label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default ChargingFeeDiscountTargetSelect
